import { withInstall } from '@ll-plus/utils'

import OperateTree from './src/operate-tree.vue'

export const LlOperateTree = withInstall(OperateTree)
export default LlOperateTree
export * from './src/operate-tree'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlOperateTree: typeof OperateTree
  }
}
